import { on } from 'delegated-events';
import createPills from './create-pills';
import { WishlistDrawing } from './wishlist';
import dropdownPicker from './dropdown-picker';
import { scrollToElement, getHeaderHeight } from './scroll-to-element';


import { showLoader, hideLoader } from './utils/utils';

let pjaxInstance = null;
let pjaxReadyResolve = null;
const pjaxReady = new Promise(resolve => { pjaxReadyResolve = resolve; });

// Po podmianie wynikow uzytkownik ma zobaczyc, co sie stalo. Gdy siatka produktow
// jest w kadrze (filtr klikniety obok produktow), zostajemy w miejscu - zmiana jest
// widoczna sama z siebie. Gdy kadr jest poza siatka (filtry nisko w kolumnie albo
// wyniki skurczyly sie po przefiltrowaniu), przewijamy do poczatku listingu:
// naglowka z licznikiem i pigulkami. Na mobile nic nie robimy - kanwa zostaje otwarta.
function revealResults() {
    if (document.body.classList.contains('show-filter')) return;

    const list = document.querySelector('.products-list');
    const anchor = [...document.querySelectorAll('.navigation-wrapper, .listing-wrapper .infobox, .products-list')]
        .find(el => el.offsetHeight > 0);

    if (!anchor) return;

    // miara po kartach, nie po pudelku listy - odporna na layouty, w ktorych
    // pudelko listy jest rozciagniete ponizej ostatniej karty
    const lastCard = list && list.lastElementChild;

    if (lastCard) {
        const top = list.getBoundingClientRect().top;
        const bottom = lastCard.getBoundingClientRect().bottom;
        const visiblePart = Math.min(bottom, window.innerHeight) - Math.max(top, getHeaderHeight());

        if (visiblePart >= Math.min(200, bottom - top)) return;
    }

    scrollToElement(anchor);
}

function pjaxFormSubmit(form) {
    const formEl = document.querySelector(`${form}`);
    if (!formEl) return;

    if (typeof (Event) !== 'function') {
        formEl.submit();
        return;
    }

    formEl.dispatchEvent(new Event('submit', {
        bubbles: true,
        cancelable: true,
        type: 'submit'
    }));
}

function getPjaxInstance() {
    return pjaxInstance;
}

function whenPjaxReady() {
    return pjaxReady;
}

export default function () {
    const pjaxContainer = document.querySelector('#pjax-container');

    if (!pjaxContainer) return;

    import('pjax/pjax.js').then(module => {
        const Pjax = module.default;

        pjaxInstance = new Pjax({
            elements: "#filter",
            selectors: ["#pjax-container"],
            scrollRestoration: false,
            scrollTo: false,
            cacheBust: false,
            switches: {
                "#pjax-container": Pjax.switches.innerHTML
            }
        });

        window.pjaxInstance = pjaxInstance;
        if (pjaxReadyResolve) pjaxReadyResolve(pjaxInstance);

        document.addEventListener('pjax:send', function () {
            showLoader();
        });

        document.addEventListener('pjax:complete', function () {
            window.lazyLoadInstance.update();
            hideLoader();
        });

        document.addEventListener('pjax:complete', function (xhr) {
            createPills();
            WishlistDrawing();
            dropdownPicker();

            const filterBottomButton = document.querySelector('.close-filter-bottom > span');

            if (filterBottomButton) {
                filterBottomButton.setAttribute('data-count', `(${xhr.request.getResponseHeader('x-filtered-count')})`);
            }

            // pickery z paska na mobile (sortowanie, ilosc na stronie) przenosi do kanwy filter-loader -
            // jego handler pjax:complete (restoreFilter) idzie przed tym
        });

        document.addEventListener('pjax:complete', revealResults);

        on('click', '.dropdown-picker input[type="radio"]', function () {
            const dropdownPickerType = this.closest('.dropdown-picker').getAttribute('data-dropdown-type');
            const target = document.querySelector(`#filter [name="${dropdownPickerType}"]`);
            // "Domyślne" ma pusta wartosc, a Razor pomija pusty atrybut value - radio.value dalby wtedy "on"
            const value = this.getAttribute('value') || '';

            if (target) {
                target.value = value;
                pjaxFormSubmit('#filter');
                return;
            }

            const url = new URL(window.location.href);

            if (value) {
                url.searchParams.set(dropdownPickerType, value);
            } else {
                url.searchParams.delete(dropdownPickerType);
            }

            pjaxInstance.loadUrl(url.toString());
        });

        // zaznaczenie calej grupy koloru odhacza jej skladowe; disabled trzyma je
        // poza submitem (filtruje sam common=, feature= nie moze dostac skladowych)
        function syncCommonChildren(input) {
            if (input.name !== 'common') return;

            const row = input.closest('li');
            if (!row) return;

            row.querySelectorAll('.common-children input[type="checkbox"]').forEach(child => {
                child.checked = input.checked;
                child.disabled = input.checked;

                // pjax serializuje takze disabled inputy (parseFormElements pomija
                // disabled tylko na <select>), wiec skladowe objete grupa musza
                // stracic name - inaczej dubluja sie w URL jako feature=
                if (input.checked) {
                    child.removeAttribute('name');
                } else {
                    child.name = 'feature';
                }
            });
        }

        on('change', '#filter input[type="checkbox"]', function () {
            syncCommonChildren(this);
            pjaxFormSubmit('#filter');
        });

        on('click', '#pills-container .single-pill[data-pill-id]', function () {
            const pillId = this.getAttribute('data-pill-id');
            const filterInput = document.querySelector(`.gs-filtr-container input[id="${pillId}"]`);

            if (filterInput) {
                filterInput.checked = false;
                syncCommonChildren(filterInput);
                pjaxFormSubmit('#filter');
                return;
            }

            const sep = pillId.lastIndexOf('_');
            if (sep === -1) return;

            const queryType = pillId.substring(0, sep);
            const value = pillId.substring(sep + 1);
            const url = new URL(window.location.href);
            const current = url.searchParams.getAll(queryType)
                .flatMap(v => v.split(','))
                .filter(Boolean);
            const next = current.filter(v => v !== value);

            url.searchParams.delete(queryType);
            if (next.length > 0) {
                url.searchParams.set(queryType, next.join(','));
            }

            pjaxInstance.loadUrl(url.toString());
        });

        on('click', '.remove-all-filters', function () {
            const url = new URL(window.location.href);


            const paramsToKeep = []; //['sort', 'page', 'view'];

            [...url.searchParams.keys()].forEach(key => {
                if (!paramsToKeep.includes(key)) {
                    url.searchParams.delete(key);
                }
            });

            window.location.href = url.toString();
        });

        createPills();
    });
}

export { pjaxFormSubmit, getPjaxInstance, whenPjaxReady };
